import React from "react";
import { Link } from "react-router-dom";
import { Unit } from "../common/api";
import { CellCover, CELL_COVER_SIZE } from "../common/CommonStyles";
import { t } from "i18next";
import {
  AnalyticsContext,
  FeaturedUnitCellTapEvent,
  WeeklySpecialsCellTapEvent,
} from "../common/context/AnalyticsContext";

export enum FeaturedUnitLoggingContext {
  None,
  Featured,
  WeeklySpecial,
}

export const FeaturedUnitItem = ({
  unit,
  loggingContext = FeaturedUnitLoggingContext.None,
}: {
  unit: Unit;
  loggingContext?: FeaturedUnitLoggingContext;
}) => {
  const displayAsLesson = unit.display_as_lesson && unit.first_lesson != null;
  const { logEvent } = React.useContext(AnalyticsContext);

  return (
    <Link
      to={
        displayAsLesson
          ? `/lessons/${unit.first_lesson!.id}/${unit.first_lesson!.slug}/`
          : `/courses/${unit.id}/${unit.slug}/`
      }
      style={{ textDecoration: "none" }}
      onClick={() => {
        switch (loggingContext) {
          case FeaturedUnitLoggingContext.Featured:
            logEvent(new FeaturedUnitCellTapEvent(unit.id, unit.title));
            break;
          case FeaturedUnitLoggingContext.WeeklySpecial:
            logEvent(new WeeklySpecialsCellTapEvent(unit.id, unit.title));
            break;
          case FeaturedUnitLoggingContext.None:
            break;
        }
      }}
    >
      <CellCover
        url={unit.cover_image}
        alt={t("unit_cover_content_description", { title: unit.title })}
        size={CELL_COVER_SIZE}
        isElevated
      />
    </Link>
  );
};
